import React, {useEffect} from 'react';
import {OverlayTrigger} from 'shared/components/OverlayTrigger';
import {useRoomPlannerContext} from '../../RoomPlannerContext';
import FloatingMenuButton, {
    FloatingMenuButtonIcon,
} from 'components/customer/RoomPlanner/components/common/FloatingMenuButton';
import {useEditProduct} from 'components/customer/RoomPlanner/components/FloatingMenu/Actions/useEditProduct';
import {
    useIsMobileLandscape,
    useIsPortraitDevices,
} from 'shared/helpers/DeviceSize';

const Edit = () => {
    const {handleEditClick} = useEditProduct();
    const isMobileLandscape = useIsMobileLandscape();
    const isPortraitDevices = useIsPortraitDevices();
    const {setEditModeHandler} = useRoomPlannerContext();

    // Register the edit mode handler with the context for keyboard shortcut
    useEffect(() => {
        if (setEditModeHandler) {
            setEditModeHandler(handleEditClick);
        }
        return () => setEditModeHandler?.(null);
    }, [handleEditClick, setEditModeHandler]);

    return (
        <OverlayTrigger placement="top" overlay={<strong>Edit (E)</strong>}>
            <FloatingMenuButton onClick={handleEditClick}>
                <FloatingMenuButtonIcon
                    className="icon_button"
                    color={
                        isMobileLandscape || isPortraitDevices
                            ? undefined
                            : '#b2bec3'
                    }
                    iconName="Button-Edit-Primary.svg"
                />
                <label>Edit</label>
            </FloatingMenuButton>
        </OverlayTrigger>
    );
};

export default Edit;
